import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';

const App = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;